import type { KabiliyetAdi } from "@parafon/contracts/sertifika";

/** Türkçe sözlük · ayarlar. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const ayarlar = {
  ekran: {
    baslik: "Ayarlar",
    aciklama: "Tema, depo bilgisi ve veri çıkış/giriş.",
  },

  /** Kalıcı uyarı: kalın ve kod parçaları arasındaki metinler. */
  kaliciUyari: {
    baslik: "Yedeğinizi almadan veri girmeyin",
    kaliciDegil: "Tarayıcı depolaması kalıcı değil.",
    persistOnce: " bu ortamda ",
    persistSonra:
      " döndü — yani tarayıcı yer açmak için veritabanını haber vermeden silebilir. Site verisini temizlemek de aynı sonucu verir.",
    yuzdenOnEk: "Bu yüzden: aşağıdaki ",
    depolama: "Depolama",
    bolumunden: " bölümünden ",
    bulutDepolama: "bulut depolamayı",
    secinYaDa: " seçin (kasanın şifreli kopyası her değişiklikte buluta yazılır) ya da ",
    sifreliYedek: "şifreli yedek (.pfai)",
    sonEk: " dosyasını elle alıp cihaz dışında saklayın. Bulut kopyası kasanın parolasıyla ya da 24 kelimelik kurtarma ifadesiyle açılır; ikisini birlikte kaybederseniz kurtarılamaz. Elle indirilen yedek yalnızca indirirken girdiğiniz parolayla açılır; otomatik indirilen yedek bulut kopyası gibi açılır.",
  },

  sahte: {
    baslik: "Depo şu an SAHTE",
    metin:
      "Arayüz, gerçek yerel çekirdek (SQLite + OPFS + Worker) yerine bellek-içi geliştirme sahtesine bağlı. Girdiğiniz hiçbir şey sayfa yenilendiğinde kalmaz.",
  },

  gorunum: {
    baslik: "Görünüm",
    tema: "Tema",
    uygulanan: (tema: string) => `Şu an uygulanan: ${tema}`,
    koyuKucuk: "koyu",
    acikKucuk: "açık",
    sistem: "Sistem tercihi",
    acik: "Açık",
    koyu: "Koyu",
    koyuTema: "Koyu tema",
    menuZemini: "Menü bölümüne göre sayfa zemini",
    iciZemin: "Sayfa içi bölümleri renkle ayır",
    zeminAciklama: "Renkler yalnızca ayırt etmek içindir, bir anlam taşımaz. Seçim kasayla birlikte öbür cihazlarınıza da gider.",
    dil: "Dil",
    dilAciklama: "Seçim yalnızca bu cihazda saklanır. Değiştirince sayfa yeniden yüklenir.",
    kartSeti: "Varlık Dökümü kartları",
    kartSetiTemel: "Temel (5 kart)",
    kartSetiAyrintili: "Ayrıntılı (önceki kartlar)",
    kartSetiAciklama: "Seçim yalnızca bu cihazda saklanır.",
  },

  depo: {
    baslik: "Depo bilgisi",
    semaSurumu: "Şema sürümü",
    kaliciDepolama: "Kalıcı depolama",
    evet: "evet",
    hayir: "hayır",
    tahminiKota: "Tahmini kota",
    cihazKimligi: "Cihaz kimliği",
    kayitliAyarlar: "Kayıtlı ayarlar",
    okunuyor: "Ayarlar okunuyor…",
    okunamadi: "Ayarlar okunamadı.",
    bos: "Depoda kayıtlı ayar yok.",
  },

  pfai: {
    baslik: "Şifreli yedek (.pfai)",
    p1OnEk:
      "Kasanız yalnızca bu tarayıcıda duruyor. Site verisini temizlerseniz, tarayıcı depolamayı boşaltırsa ya da cihaz değişirse ",
    p1Kalin: "kasa gider.",
    p1SonEk: " Şifreli yedek, kasanın cihazdan çıkabilen tek biçimi.",
    p2OnEk: "Şifreleme ",
    p2Kalin1: "bu cihazda",
    p2Orta: " yapılıyor: parola ve veriler sunucuya hiç gitmiyor. Bunun bedeli şu — ",
    p2Kalin2: "parolayı kaybederseniz dosya kurtarılamaz.",
    p2SonEk: " Arka kapı yok, sıfırlama yok.",
    parola: "Parola",
    parolaTekrar: "Parola (tekrar)",
    sifreleniyorUc: "Şifreleniyor…",
    sifreleniyor: "Şifreleniyor",
    indir: "Şifreli yedek indir",
    parolalarFarkli: "İki parola aynı değil.",
    indirildi: "Şifreli yedek indirildi. Parolayı güvenli bir yerde saklayın.",
    yedekTarihi: (an: string) => `Yedek tarihi: ${an}`,
    geriBaslik: "Yedekten geri yükle",
    g1OnEk: "Geri yükleme ",
    g1Kalin1: "birleştirir, silmez",
    g1Orta: ": yedekte olmayan kayıtlarınız yerinde kalır. Aynı kaydın iki sürümü varsa ",
    g1Kalin2: "daha yeni sürüm",
    g1SonEk: " kazanır — yani bir yedeği geri yüklemek kasanızı geriye götürmez.",
    yedekParolasi: "Yedeğin parolası",
    yedekParolasiIpucu: "Otomatik indirilen yedekte kasanın parolası.",
    dosyaSec: ".pfai dosyası seç",
    cozuluyor: "Çözülüyor",
    geriTamam: "Geri yükleme tamamlandı",
  },

  json: {
    baslik: "Şifresiz JSON (geliştirici aracı)",
    onEk: "ŞİFRESİZ tam yedek — dosyayı açan herkes bütün portföyünüzü okur. Normal yedekleme için yukarıdaki ",
    sonEk: " biçimini kullanın; bu bir acil çıkış kapısı ve geliştirici aracıdır.",
    hazirlaniyor: "Hazırlanıyor…",
    indir: "JSON indir",
    yukle: "JSON'dan yükle",
    yukleniyor: "Yükleniyor",
    tamam: "Yükleme tamamlandı",
  },

  nakit: {
    baslik: "Nakit takibi",
    aciklama:
      "Açıkken Varlık Dökümü hesap başına net nakit hareketini gösterir (yatırma, çekme, alış, satış, temettü ve masrafların nakde etkisi). Nakdinizi izlemiyorsanız kapatın; temettü, faiz ve masraf getiriye yine girer.",
    okunamadi: "Ayar okunamadı.",
    kaydedilemedi: "Ayar kaydedilemedi.",
    okunuyor: "Okunuyor…",
    suAn: (durum: string) => `Şu an: ${durum}`,
    acikKucuk: "açık",
    kapaliKucuk: "kapalı",
  },

  /** ABD seans dışı fiyat seçimi (kullanıcı kararı 04.11.2026). */
  seansDisi: {
    baslik: "ABD'de seans dışı fiyat",
    aciklama:
      "ABD borsalarında seans öncesi (New York 04:00–09:30), seans sonrası (16:00–20:00) ve gece seansı (20:00–04:00) işlemleri de izlenir; gece fiyatının işlem saati kaynakta yok, sorulduğu an gösterilir. Bugünkü değerin hangi fiyatla hesaplanacağını seçin. Geçmiş günler her zaman seans kapanışıyla değerlenir.",
    kapanis: "Seans kapanış fiyatı",
    seansDisi: "Daha yeniyse seans dışı fiyat",
  },

  /** Abonelik kartı. */
  abonelik: {
    baslik: "Abonelik",
    acikKabiliyetler: "Açık kabiliyetler",
    hal: {
      yukleniyor: "Denetleniyor…",
      sertifikasiz: "Ücretsiz kullanım. Ücretli kabiliyetler aktivasyon koduyla açılır.",
      kapiYok: "Bu oturumda abonelik sunucusuna bağlanılmıyor; kasa ücretsiz sınırlarla açık.",
      suresiz: "Ücretli · süresiz.",
      tarihineKadar: (gun: string) => `Ücretli · ${gun} tarihine kadar.`,
      sonTeyit: (an: string) =>
        `Sunucuya şu an ulaşılamıyor; son teyit ${an}. ` +
        "48 saat içinde teyit edilmezse ücretli kabiliyetler kapanır; kayıtlarınız silinmez.",
      teyitEskidi:
        "Sunucuya 48 saattir ulaşılamadı; ücretli kabiliyetler kapalı. İnternete bağlanınca kendiliğinden açılır.",
      suresiDoldu: "Ücretli kabiliyetlerin süresi doldu. Kayıtlarınız silinmedi.",
      baskaCihazda: "Bu kasa başka bir cihazda açıldığı için buradaki ücretli oturum kapandı (oturum sınırı).",
      gecersiz: "Sunucu bu kasadaki sertifikaları tanımadı; ücretli kabiliyetler kapalı.",
    },
    hata: {
      kodYok: "Kod tanınmadı ya da daha önce kullanılmış.",
      gecersiz: "Kod biçimi geçersiz.",
      muhur: "Bu kod bu sunucuda kullanılamaz.",
      cokDeneme: "Çok fazla deneme yapıldı; bir saat sonra yeniden deneyin.",
      ulasilamadi: "Abonelik sunucusuna ulaşılamadı; biraz sonra yeniden deneyin.",
      kapiYok: "Bu oturumda abonelik sunucusuna bağlanılmıyor.",
      buEkrandaYok: "abonelik bu ekranda kullanılamıyor",
      sertifikaYok: "sunucu sertifika göndermedi",
      sertifikaOkunamadi: "sunucunun gönderdiği sertifika okunamadı",
      sertifikaGecersiz: (sebep: string) => `sunucunun gönderdiği sertifika geçersiz: ${sebep}`,
      baskaKasa: "sertifika başka bir kasaya basılmış",
    },
    butunKabiliyetler: "bütün kabiliyetler",
    kodKullanildi: (adlar: string) => `Kod kullanıldı: ${adlar} açıldı.`,
    eskisiDustu: "Oturum sınırı dolu olduğu için en eski oturum kapatıldı.",
    yenidenAc: "Bu cihazda yeniden aç",
    sinirDoluysa: "Sınır doluysa en eski oturum kapanır.",
    kod: "Aktivasyon kodu",
    gonderiliyor: "Gönderiliyor…",
    kodKullan: "Kodu kullan",
  },

  /** Kilitli kabiliyet ifadesi ve sınır cümleleri. */
  kilit: {
    ucretli: (ne: string) => `${ne} ücretli bir kabiliyet.`,
    etiket: "Ücretli kabiliyet",
    abonelik: "Abonelik",
    sunucuYedegi: "Parafon sunucusuna yedek ücretli bir kabiliyet (Abonelik).",
    bulutYedegi: "Kendi bulutunuza otomatik yedek ücretli bir kabiliyet (Abonelik).",
    varlikSiniri: (eldeki: number, sinir: number) =>
      `Bu hesapta ${eldeki} farklı varlık var; ücretsiz kullanımda hesap başına en çok ${sinir}. Satış ve eldeki varlıklara ek alım girilebilir.`,
    sanalHesap: "Sanal hesap",
    sanalFazlasi: (n: number) => `${n} sanal hesaptan fazlası`,
    sanalB: "B tipi (gerçek hesapların para akışı)",
    dengeleme: "Dengeleme",
  },
  /** Kabiliyet adları (sözleşmedeki `KABILIYETLER` sırası). */
  kabiliyetAdi: {
    "gecis": "Ücretliye geçiş paketi",
    "ek-hesap": "Ek hesap",
    "ek-oturum": "Ek oturum",
    "ek-kasa": "Ek kasa",
    "fiyat-gecmisi": "Fiyat geçmişi (5 yıllık dilim)",
    "gecmis-gun": "Varlık Dökümü: geçmiş bir gün",
    "donemsel-getiri": "Dönemsel Getiri",
    "sanal-hesap": "Sanal hesap (üçlü paket)",
    "sanal-b": "Sanal hesap: B tipi",
    "sanal-dengeleme": "Sanal hesap: dengeleme",
    "sanal-paylasim": "Sanal hesap: paylaşım",
    "ice-aktarma": "İçe aktarma (CSV)",
    "kurum-ekstresi": "Kurum ekstresinden alma",
    "depolama-bulut": "Kendi buluta otomatik yedek",
    "depolama-sunucu": "Parafon sunucusuna yedek",
    "depolama-kota": "Yedek kotası",
    "surum-gecmisi": "Yedek sürüm geçmişi",
  },
};

// Her kabiliyetin adı var (eksik kabiliyet derlemede düşer).
ayarlar.kabiliyetAdi satisfies Readonly<Record<KabiliyetAdi, string>>;
